import { refreshToken } from '../index'

export default (http, router) => {
  // Trabalhando os interceptors do http

  http.interceptors.request.use(
    config => {
      return config
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  http.interceptors.response.use(
    response => response,
    (error) => {
      const { response } = error
      const { headers } = response.config

      if (error.response.status === 401 && !headers['x-request-login']) {
        return refreshToken()
          .then((token) => {
            response.config.headers.Authorization = `Bearer ${token}`
            return http(response.config)
          })
          .catch(() => {
            router.push({ name: 'auth.singin' })
          })
      }
      return Promise.reject(error)
    }
  )
}



// WEBPACK FOOTER //
// ./src/app/auth/services/http/interceptors.js